import React from 'react';

const Hero = () => {
  const scrollToManuscripts = () => {
    const element = document.getElementById('manuscripts');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="hero">
      <div className="sanskrit-blessing">सत्यं शिवं सुन्दरम्</div>
      <h1>Where Ancient Wisdom Lives</h1>
      <p className="hero-subtitle">
        Converse with the eternal teachings of India's sacred manuscripts through the clarity of artificial intelligence
      </p>
      <a href="#manuscripts" className="explore-btn" onClick={(e) => { e.preventDefault(); scrollToManuscripts(); }}>
        EXPLORE TEXTS
      </a>
    </section>
  );
};

export default Hero; 